export async function leaveChimeSession(
  meetingManager: any
): Promise<void> {
  try {
    await meetingManager.leave();
  } catch (error) {
    console.error("Error leaving Chime session:", error);
    throw error;
  }
}
